import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy" data-id="element-129" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-130" data-mp="3gezcj1s77n03">
        <h3 className="font-display text-2xl font-semibold text-white" data-id="element-131" data-mp="3ggka709t7m26">52 Weeks of Art-Based Sessions</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-132" data-mp="32lrm3dfusxjz">
          The 4-Step Session Arc: because planning sessions shouldn&apos;t cost
          you every evening of the week.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/75" data-id="element-133" data-mp="3ucxmzw3eezab">
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-134" data-mp="36d1erw44jko">help@iclcollective.com</a>
        </div>
        <p className="mx-auto mt-7 max-w-2xl border-t border-white/15 pt-5 text-xs leading-relaxed text-white/55" data-id="element-135" data-mp="3qcx86ace0m2q">
          52 Weeks of Art-Based Sessions is an educational resource for
          counselors, therapists, social workers and art therapists working
          within their training, license and scope of practice. These are
          art-based session plans, not a substitute for art therapy training,
          clinical judgment or supervision. Sessions marked Deep are for
          clinicians trained in trauma-informed or art therapy practice. If a
          client shows risk of harm, follow your setting&apos;s safety protocol
          and refer. If a client discloses abuse, follow your mandated-reporting
          or safeguarding duties. No clinical outcomes are promised. Not
          affiliated with or endorsed by any professional association or
          licensing body. © 52 Weeks of Art-Based Sessions 2026. All rights
          reserved.
        </p>
      </div>
    </footer>;
}